<template>
  <div class="option-selector">
    <template v-if="control.likeSelect">
      <dm-select
        v-if="control.oneFlag"
        :value="localValue"
        :placeholder="control.hint"
        :disabled="disabled"
        @input="emitVal"
        filterable
        :allow-create="control.allowAdd"
        clearable
      >
        <template #tag="item">
          <el-tag
            disable-transitions
            :class="[_.get(optionMap, item.option.value + '.color'), 'single-tag']"
            :color="disabled ? '#f5f7fa' : '#ffffff'"
            style="
                  border-radius: 6px;
                  padding: 0 4px;
                  color: white;
                  display: inline;
                  font-size: 14px;
                  line-height: 16px;
                "
          >
            <span v-if="_.get(optionMap, item.option.value + '.color')">
              {{ item.option.currentLabel }}
            </span>
            <span v-else style="color:#303133">
              {{ item.option.currentLabel }}
            </span>
          </el-tag>
        </template>
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
          <span
            v-if="item.color"
            :class="[item.color, 'custom-option']"
            style="border-radius: 6px; padding: 1.5px 5px; color: white"
          >
            {{ item.label }}
          </span>
        </el-option>
      </dm-select>
      <dm-select
        v-else
        ref="dmSelect"
        :value="localValue"
        multiple
        :disabled="disabled"
        :placeholder="control.hint"
        @input="emitVal"
        class="select-back"
        :allow-create="control.allowAdd"
        filterable
        clearable
        default-first-option
      >
        <template #tagOut="item">
          <div
            :class="_.get(optionMap, item.option.value + '.color')"
            v-if="_.get(optionMap, item.option.value + '.color')"
            style="padding: 1.5px 5px; border-radius: 4px; border-width: 1px; border-style: solid; color: white; margin-left: 5px;"
          >
            <span>
              {{ item.option.currentLabel }}
            </span>
            <svg-icon
              icon-class="svgo_close-round"
              class="svg-icon_close-btn"
              @click.native="$refs.dmSelect.deleteTag($event, item.option)"
            ></svg-icon>
          </div>
          <div
            v-else
            style="padding: 1.5px 5px;border-radius: 4px;  border-width: 1px; border-style: solid;border-color: #e9e9eb; color: #303133; margin-left: 5px;background-color: #f4f4f5"
          >
            <span>
              {{ item.option.currentLabel }}
            </span>
            <svg-icon
              icon-class="svgo_close-round"
              class="svg-icon_close-btn"
              @click.native="$refs.dmSelect.deleteTag($event, item.option)"
            ></svg-icon>
          </div>
        </template>
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
          <span
            v-if="item.color"
            :class="[item.color, 'custom-option']"
            style="border-radius: 6px; padding: 1.5px 5px; color: white"
          >
            {{ item.label }}
          </span>
          <span v-else class="custom-option" style="border-radius: 6px; padding: 1.5px 5px">
            {{ item.label }}
          </span>
        </el-option>
      </dm-select>
    </template>
    <template v-else>
      <el-radio-group
        v-if="control.oneFlag"
        :value="localValue"
        :disabled="disabled"
        @input="emitVal"
        class="overlong-style"
      >
        <el-radio v-for="item in options" :key="item.value" :label="item.value">
          <span
            v-if="item.color"
            class="cellOption"
            style="color: #fff !important"
            :class="item.color"
          >
            {{ item.value }}
          </span>
          <span v-else class="cellOption">{{ item.value }}</span>
        </el-radio>
      </el-radio-group>
      <el-checkbox-group
        v-else
        :value="localValue"
        @input="emitVal"
        :disabled="disabled"
        text-color="white"
      >
        <el-checkbox
          v-for="item in options"
          :key="item.value"
          :label="item.value"
          :title="item.label"
        >
          <span
            v-if="item.color"
            :class="['cellOption', item.color]"
            style="color: #fff !important"
          >
            {{ item.label }}
          </span>
          <span v-else class="cellOption">{{ item.label }}</span>
        </el-checkbox>
      </el-checkbox-group>
    </template>
  </div>
</template>

<script>
import DmSelect from "@/components/BaseComponents/DmSelect"
import { getControlOptions } from "@/utils/sheet"

export default {
  name: "option-selector",
  components: {
    DmSelect
  },
  props: {
    value: Array,
    control: Object,
    disabled: Boolean,
    form: Object
  },
  data() {
    return {}
  },
  computed: {
    hasColor() {
      return Boolean(this.control?.options[0].color)
    },
    localValue() {
      return this.control.oneFlag ? this.value?.[0] || "" : this.value || []
    },
    options() {
      return getControlOptions(this.control, this.form)
    },
    optionMap() {
      return this._.keyBy(this.control?.options || [], "value")
    }
  },
  methods: {
    emitVal(val) {
      if (val && this.control.allowAdd) {
        // 当类型是动态数据源 或者 设置了依赖关系的时候, allowAdd 肯定是假
        this.control.options = this.control.options.concat(
          []
            .concat(val)
            .filter(v => !this.options.some(item => item.value === v))
            .map(v => ({
              label: v,
              value: v,
              color: this.hasColor ? "option-bg-blue" : null
            }))
        )
      }
      this.$emit("input", this.control.oneFlag ? (val ? [val] : []) : val || [])
    }
  }
}
</script>

<style lang="scss" scoped>
.option-selector {
}
</style>
